import { useTranslation } from '@/i18n';
import { ButtonV2 } from '@moneyforward/ap-frontend-components';
import styles from './Footer.module.scss';

type FooterProps = {
  onCancel: () => void;
  onApply: () => void;
  isLoadingApplyPastTransactions: boolean;
};

export const Footer: React.FC<FooterProps> = ({
  onCancel,
  onApply,
  isLoadingApplyPastTransactions,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.drawerFooter}>
      <ButtonV2
        size='sm'
        type='button'
        color='primary'
        isSecondary
        onClick={onCancel}
      >
        {t('cancel')}
      </ButtonV2>
      <ButtonV2
        size='sm'
        type='button'
        color='primary'
        onClick={onApply}
        isLoading={isLoadingApplyPastTransactions}
      >
        {t('apply')}
      </ButtonV2>
    </div>
  );
};
